type TStepWithHelperWork = {
    hasOutstandingWorkForOthers?: boolean;
};

export const sortStepsForCompleteState = <A extends TStepWithHelperWork>(steps: Array<A>): Array<A> =>
    [...steps].sort((a, b) =>
        !!a.hasOutstandingWorkForOthers === !!b.hasOutstandingWorkForOthers ? 0
        : a.hasOutstandingWorkForOthers ? -1
        : 1
    );
